(() => {
  const instances = new WeakMap();
  const mount = root => {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const { signal } = abort;
    let frame = 0;
    const dropdowns = [...root.querySelectorAll('#hdt-nav-ul > li > hdt-header-menu > details')];
    const firstSection = document.querySelector('#MainContent > .hdt-section:first-child');
    root.dataset.overHero = String(!!firstSection?.classList.contains('section-allow-transparent'));
    const updateScroll = () => {
      frame = 0;
      root.dataset.scrolled = String(window.scrollY > 48);
    };
    const setOpen = (details, open) => {
      if (typeof details.parentElement.toggle === 'function') details.parentElement.toggle(open);
      else {
        details.open = open;
        details.querySelector('summary')?.setAttribute('aria-expanded', String(open));
      }
    };
    const updateMenu = () => {
      root.dataset.headerOpen = String(dropdowns.some(details => details.open && details.querySelector('summary')?.getAttribute('aria-expanded') !== 'false'));
    };
    const closeMenus = () => {
      dropdowns.forEach(details => setOpen(details, false));
      updateMenu();
    };
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(updateScroll); }, { passive: true, signal });
    window.addEventListener('pageshow', updateScroll, { signal });
    dropdowns.forEach((details, index) => {
      const summary = details.querySelector('summary');
      const panel = summary?.nextElementSibling;
      if (!summary) return;
      if (!summary.hasAttribute('aria-expanded')) summary.setAttribute('aria-expanded', String(details.open));
      if (panel) {
        panel.id ||= `${root.closest('[id]')?.id || 'icafe-header'}-submenu-${index}`;
        summary.setAttribute('aria-controls', panel.id);
      }
      details.addEventListener('toggle', () => {
        if (details.open) dropdowns.filter(item => item !== details).forEach(item => setOpen(item, false));
        updateMenu();
      }, { signal });
      summary.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        setOpen(details, true);
        updateMenu();
        requestAnimationFrame(() => Promise.allSettled((panel?.getAnimations() || []).map(animation => animation.finished)).then(() => {
          if (details.open) panel?.querySelector('a[href]')?.focus();
        }));
      }, { signal });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        event.stopPropagation();
        setOpen(details, false);
        updateMenu();
        summary.focus();
      }, { signal });
    });
    document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) closeMenus(); }, { signal });
    root.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (!root.contains(document.activeElement)) closeMenus();
    }), { signal });
    const dialogObservers = [];
    root.querySelectorAll('[aria-controls]').forEach(trigger => {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog || dialog.tagName !== 'DIALOG') return;
      trigger.setAttribute('aria-haspopup', 'dialog');
      const sync = () => trigger.setAttribute('aria-expanded', String(dialog.open));
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      dialogObservers.push(observer);
    });
    const mobileDialog = document.getElementById('menu_mobile');
    const mobileTrigger = root.querySelector('.hdt-menu-bar[aria-controls="menu_mobile"]');
    const closeMobile = event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof mobileDialog.parentElement.close === 'function') mobileDialog.parentElement.close(true);
      else mobileDialog.close();
      requestAnimationFrame(() => mobileTrigger?.focus({ preventScroll: true }));
    };
    mobileDialog?.querySelector('[ref="closeButton"]')?.addEventListener('click', closeMobile, { capture: true, signal });
    mobileDialog?.addEventListener('cancel', closeMobile, { capture: true, signal });
    const count = root.querySelector('hdt-cart-count');
    let countObserver;
    if (count) {
      const updateCount = () => { count.dataset.count = count.textContent.trim(); };
      countObserver = new MutationObserver(updateCount);
      countObserver.observe(count, { childList: true, characterData: true, subtree: true });
      updateCount();
    }
    updateScroll();
    updateMenu();
    instances.set(root, () => {
      abort.abort();
      cancelAnimationFrame(frame);
      countObserver?.disconnect();
      dialogObservers.forEach(observer => observer.disconnect());
      instances.delete(root);
    });
  };
  const init = () => document.querySelectorAll('.ic-header-v12').forEach(mount);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.ic-header-v12').forEach(root => instances.get(root)?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
